module.exports = "<div ui-view></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/olr-mainfe/content.html
 ** module id = 266
 ** module chunks = 1
 **/